import { ApiManager, Sites } from '@pmi/pmi-iqos-shared-react'
import IqosphereAuth from './api/iqosphere-auth'
import IqosphereLottery from './api/iqosphere-lottery'
import IqospherePackCode from './api/iqosphere-packCode'
import IqosphereProfile from './api/iqosphere-profile'
class IqosphereApiManager extends ApiManager {
  defaultHeaders = {
    'Content-Type': 'application/json'
  }

  errorCodeTranslationMap = {
    qs_01: 'tk_queryParameterTokenMissing'
  }

  constructor(site) {
    super(site)
    this.iqosphereAuth = new IqosphereAuth(this)
    this.iqosphereLottery = new IqosphereLottery(this)
    this.iqospherePackCode = new IqospherePackCode(this)
    this.iqosphereProfile = new IqosphereProfile(this)
  }

  getMock = mock => {
    return () => {
      return require(`../mocks/${mock}.json`)
    }
  }
}

export default new IqosphereApiManager(Sites.iqosphere)
